import { has } from 'lodash';

const sanitizationFns = {
  none: result => result,
  number: (result) => {
    const newResult = { ...result };

    if (newResult?.value && typeof newResult.value === 'string' && newResult.value.includes('NaN')) {
      newResult.value = '';
    }

    if (newResult?.value && typeof newResult.value === 'string' && newResult.value?.indexOf(',') !== -1) {
      newResult.value = newResult.value.replace(/,/g, '');
    }
    return newResult;
  },
};

export default (result = {}, resultTypeToSanitize = 'none') => {
  if (!result || !resultTypeToSanitize) {
    return result;
  }

  if (has(sanitizationFns, resultTypeToSanitize)) {
    return sanitizationFns[resultTypeToSanitize](result);
  }
  return result;
};
